import React, {useEffect, useState} from "react";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Collapse from "@material-ui/core/Collapse";
import Icon from "../../../../UI/Icon/Icon";
import html from "react-inner-html";
import "../../../CvDetails/CvDetails.css";
import Grid from "@material-ui/core/Grid";
import {translation} from "../../../../../I18n/i18n";

const moment = require ("moment");
const largeSpace = "  ";

const Experience = (props) => {
    const [expanded, setExpanded] = useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    let getCData = (elem) => {
        if (elem && elem._cdata !== '<p><br></p>') {
            return elem._cdata;
        }
        return '';
    }

    const [projectDescriptionData, setProjectDescriptionData] = useState (getCData (props.experience.ProjectDescription));
    const [responsibilitiesData, setResponsibilitiesData] = useState (getCData (props.experience.Responsibilities));
    const [environmentData, setEnvironmentData] = useState (getCData (props.experience.Environment));

    useEffect (() => {
        setProjectDescriptionData (getCData (props.experience.ProjectDescription))
    }, [props.experience.ProjectDescription]);

    useEffect (() => {
        setResponsibilitiesData (getCData (props.experience.Responsibilities))
    }, [props.experience.Responsibilities]);

    useEffect (() => {
        setEnvironmentData (getCData (props.experience.Environment))
    }, [props.experience.Environment]);

    const handleEditClick = () => {
        props.onEditClick (props.index);
    };

    const handleDeleteClick = () => {
        props.onDeleteClick (props.index);
    };

    let projectDescription = projectDescriptionData ? `${ translation (props.lang, "Project Description") } : ${ projectDescriptionData }` : "";
    let responsibilities = responsibilitiesData ? `${ translation (props.lang, "Responsibilities") } : ${ responsibilitiesData }` : "";
    let environment = environmentData ? `${ translation (props.lang, "Environment") } : ${ environmentData }` : "";

    let translateAndKeepFormat = (formattedDate, language) => {
        if (language && formattedDate.split (largeSpace).length) {
            return `${ translation (language, formattedDate.split (largeSpace)[0]) }${ largeSpace }${ formattedDate.split (largeSpace)[1] }`;
        }
        return formattedDate;
    }

    const computePeriod = () => {
        let period = props.experience.Period;
        let from = period.From;
        let to = period.To;
        let current = period.Current._text
        let formattedFrom = moment ((from._attributes.year + "/" + from._attributes.month + "/01").replace ("--", "")).format (`MMMM${ largeSpace }YYYY`);
        let translatedFrom = translateAndKeepFormat (formattedFrom, props.lang);
        if (current && (!to || to._attributes.year === "")) {
            let translatedTo = translation (props.lang, 'Current');
            return `${ translatedFrom } - ${ translatedTo }`;
        } else {
            let formattedTo = moment ((to._attributes.year + "/" + to._attributes.month + "/01").replace ("--", "")).format (`MMMM${ largeSpace }YYYY`);
            let translatedTo = translateAndKeepFormat (formattedTo, props.lang);
            return `${ translatedFrom } - ${ translatedTo }`;
        }
    };

    return (
        <Card key={props.index}>
            <Grid container className="cardTitle">
                <Grid item xs={ 11 }>
                    <CardHeader titleTypographyProps={ {variant: 'subtitle1'} } title={ props.title }
                                subheaderTypographyProps={ {variant: 'subtitle1'} }
                                subheader={ computePeriod () }/>
                </Grid>
                <Grid item xs={ 1 }>
                    { props.hasWriteAccess &&
                    <Icon classIcon="fas fa-pencil-alt" color="#464775" size="15px" margin="10px"
                          label="Edit" action={ handleEditClick }/> }
                    { props.hasWriteAccess &&
                    <Icon classIcon="fas fa-trash-alt" color="#464775" size="15px" margin="10px"
                          label="Delete" action={ handleDeleteClick }/> }
                    <Icon
                        classIcon={expanded ? "fas fa-angle-up" : "fas fa-angle-down"}
                        color="#464775"
                        margin="5px 10px 5px 10px"
                        size="15"
                        action={handleExpandClick}
                        label="show more"
                    />
                </Grid>

            </Grid>

            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent className="muiCardContent">
                        <div {...html(projectDescription)} />
                        <div {...html(responsibilities)} />
                        <div {...html(environment)} />
                </CardContent>
            </Collapse>
        </Card>
    );
};

export default Experience;
